import firebase from 'firebase/app'
import 'firebase/firestore'

var firebaseConfig = {
  apiKey: 'AIzaSyDmhv_Mc7z09EUXlfpHfIE1fWeyEI-PCF8',
  authDomain: 'my-test-project-3a0c0.firebaseapp.com',
  databaseURL: 'https://my-test-project-3a0c0.firebaseio.com',
  projectId: 'my-test-project-3a0c0',
  storageBucket: 'my-test-project-3a0c0.appspot.com',
  messagingSenderId: '504919984149',
  appId: '1:504919984149:web:3e95044fccdd75be04661c'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp
